import angular from 'angular';

angular.module('cxRegistrations').directive('cxTrainingTypeahead', [
  function() {
    return {
      restrict: 'E',
      replace: true,
      template: `<div class="dropdown dropdown-full-width" uib-dropdown ng-show="options.length" is-open="ddwOpen">
        <div class="input-group input-group-sm scrollable-typeahead {{iClass}}">
          <input type="text"
                 ng-disabled="disabled"
                 ng-model="selected"
                 uib-typeahead="item as item.label for item in options | filter:{label:($viewValue||'')} | limitTo:limit"
                 typeahead-min-length="0"
                 typeahead-select-on-blur="false"
                 typeahead-select-on-exact="true"
                 typeahead-on-select="onSelect($item, $event)"
                 typeahead-template-url="trainingTypeaheadTemplate.html"
                 ng-blur="onBlur()"
                 ng-keydown="onKeyDown($event)"
                 ng-focus="ddwOpen=false"
                 class="form-control"
                 autocomplete="off"
          />
          <span class="input-group-btn">
            <button class="btn btn-default dropdown-toggle btn-font-14"
                    ng-disabled="disabled || !options.length"
                    uib-dropdown-toggle
                    ng-click="ddwOpen=true">
              <span class="caret"></span>
            </button>
          </span>
        </div>
        <ul class="dropdown-menu" role="menu" style="max-height:300px;overflow-y:auto;">
          <li ng-repeat="op in options | filter:{label:($viewValue||'')}" ng-class="{'selected':op===selected}">
            <a href ng-click="onSelect(op)">
              <div>{{op.label}}</div>
            </a>
          </li>
        </ul>

        <script type="text/ng-template" id="trainingTypeaheadTemplate.html">
          <a>
            <div ng-bind-html="match.label | sanitize | uibTypeaheadHighlight:query"></div>
          </a>
        </script>
      </div>`,
      require: 'ngModel',
      scope: {
        orgOptions: '=options',
        disabled: '=?ngDisabled',
        placeholder: '@?',
        iClass: '@?',
      },
      link: function(scope, el, attrs, ngModel) {
        scope.limit = attrs.limit || 9999;

        function findSelected(value) {
          if (!value || !scope.options.length) return null;
          return scope.options.find(item => item && value && item.trainingId === value.trainingId);
        }

        ngModel.$render = function() {
          scope.value = ngModel.$viewValue;
          scope.selected = findSelected(scope.value) || scope.value;
        };

        scope.onSelect = function(item) {
          scope.selected = item;
          scope.value = item;
          ngModel.$setViewValue(item);
        };

        function mapOptions() {
          if (!Array.isArray(scope.orgOptions)) {
            scope.options = [];
          } else {
            scope.options = scope.orgOptions.map(x => ({
              ...x,
              label: x.label || x.name || x.trainingName,
            }));
          }
          scope.selected = findSelected(scope.value) || scope.value;
        }

        mapOptions();

        scope.$watchCollection('orgOptions', function() {
          mapOptions();
        });

        scope.onBlur = function() {
          if (typeof scope.selected === 'string') {
            scope.onSelect(null);
            return;
          }
          if (!scope.options.includes(scope.selected)) {
            scope.onSelect(null);
          }
        };
      },
    };
  },
]);
